import { render, staticRenderFns } from "./AIDiagnosisDialog.vue?vue&type=template&id=d7144784&scoped=true"
import script from "./AIDiagnosisDialog.vue?vue&type=script&lang=js"
export * from "./AIDiagnosisDialog.vue?vue&type=script&lang=js"
import style0 from "./AIDiagnosisDialog.vue?vue&type=style&index=0&id=d7144784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7144784",
  null
  
)

export default component.exports